export default {
    LaunchedMonth: {
        1: 'Launched in January',
        2: 'Launched in February',
        3: 'Launched in March',
        4: 'Launched in April',
        5: 'Launched in May',
        6: 'Launched in June',
        7: 'Launched in July',
        8: 'Launched in August',
        9: 'Launched in September',
        10: 'Launched in October',
        11: 'Launched in November',
        12: 'Launched in December',
        13: 'Soon to go online',
    },
    menu: {
        home: 'Yum Home',
        hotGame: '热门游戏',
        tryPlay: '游戏试玩',
        ourAdvantage: 'Our advantage',
        aboutUs: 'about us',
        linkUs: 'contact us',
        login: '登录',
        register: '注册'
    },
    indexPagePlay: {
        players: ' Online players: 129003',
        webTitle: "The world's top game developer",
        gameTry1: 'Game demo',
        gameTry2: 'Game demo2',
        bannerExplain: 'Pure 3D engine to create the ultimate 3D effect, immersive as the reality game massive game integration, tailored for you, follow- up update',
        inGame: 'Enter the game',
        development: 'stay tuned'
    },
    banner: {
        coming: 'coming soon',
        baijiale: "BACCARAT",
        lunpan: 'ROULETTE',
        buyu: 'CANNON FISHING',
        zhanjinhua: 'GOLDEN FLOWER',
        niuniu: 'BANKER NIU NIU',
        tuiTongzi: 'CIRCLE TILES',
        longhu: 'DRAGON&TIGER',
        dezhou: 'TEXAS HOLDEM',
        jisuhua: 'SPEED FLOWER',
        shisanshui: "THIRTEEN POKER",
        paijiu: 'PAI GOW',
        kingOfFishing3D: 'KING OF FISHING',
        shidianban: 'TEN POINT HALF',
        sangong: 'THREE FACECARD',
        ershiyidian: 'BLACK jack',
        bairenbaijiale: 'MULTI-PLAYERS BACCARAT',
        honghei: 'RED & BLACK',
        niuniu4: 'Banker Niu Niu （Cards Shown）',
        bairenniuniu: 'MULTI-PLAYERS Niu-niu',
        majiangxueliu: 'Blood river mahjong',
        benzAndBMW: ' Benz & BMW',
        forestParty: 'Forest Party',
        majiangxuezhan: 'Bleeding mahjong',
        landlord: 'Landlords(No shuffle)',
        jinsaPoker: 'Jinsa Poker',
        fanbeimajiang: 'DOUBLE BLOOD',
        pirateFishing: '3D PIRATE FISHING',
        mermaidFishing: '3D MERMAID FISHING',
        dezhou_qz: 'TEXAS HOLDEM(ANTE)',
        errenmj: "2 persons mahjong",
        ksznn_3d: "3D FOUR CARDS SHOWN NIUNIU",
        qznn_3d: "3D BANKER NIUNIU",
        ddzjs: "Landlords (rapid)",
        jokerNiuniu: "JOKER NIUNIU",
        kszqznn: "THREE CARDS SHOWN NIUNIU",
        lkpy: 'FISHING KUI LEE',
        dntg: 'MONKEY KING',
        birdingJoy:'BIRDING JOY',
        goldenCountry: 'GOLDEN COUNTRY'
    },
    ourAdvantage: {
        title1: '10mb fiber access',
        content1: 'High density optical fiber connection platform, let the user experience what is fast as lightning',
        title2: 'Multi-layer network protection',
        content2: 'High CDN, cloud anti-acceleration, we are more than fast, we are as stable as mount tai',
        title3: "Quick API access",
        content3: 'We provide a simple and fast API access solution, how to connect',
        title4: '3D game guidance',
        content4: 'Industry pure 3D engine, product experience is smooth, enter is a perfect immersive game feast',
        title5: 'Certification by authorities',
        content5: 'The game is tested by the authority of the vulnerability and given professional certification, stable operation is our purpose',
        title6: 'All-netcom one',
        content6: 'Computer, IOS, iPad, android devices, barrier-free cross-platform applications, users feel free to play',
        title7: 'Rich experience in operation and maintenance',
        content7: '10 years of operation and maintenance experience, CCIE, CCNP, CCNA certification qualification',
        title8: 'Professional customer service team',
        content8: '7*24 hours professional customer service team'
    },
    aboutUs: {
        p1: 'Yum! Chess is a game developer who focuses on the card market.',
        p2: 'We are committed to creating the perfect audio-visual feast with the most advanced 3D technology, giving players an immersive experience;',
        p3: 'We are committed to bringing fair, just and fun game platforms to our players;',
        p4: 'We are committed to helping merchant platforms enhance product competitiveness and user activity, enrich the operational tools of merchant platforms, and reduce their research and development costs.',
        moreGameTitle: 'More games, stay tuned',
        gameToggleInfo: 'Learn the first mover, create oneself, surpass me'
    },
    NavTitle: {
        online: 'Online',
        qipaiKind: 'Chess',
        electronGame: 'Electronic',
        MahjongKing: 'Mahjong',
        hunterKing: 'Hunting'
    },
    gameName: {
        online: {
            a: 'BACCARAT',
            b: 'ROULETTE',
            c: 'CANNON FISHING',
            d: 'GOLDEN FLOWER',
            e: 'BANKER NIU NIU',
            f: 'CIRCLE TILES',
            g: 'DRAGON&TIGER',
            h: 'TEXAS HOLDEM',
            i: 'SPEED FLOWER',
            j: 'RUN FAST',
            k: 'THIRTEEN POKER',
            l: 'PAI GOW',
            m: 'LANDLORDS',
            n: 'KING OF FISHING(3D)',
            u: 'TEN POINT HALF',
            v: 'THREE FACECARD',
            lkpy: 'FISHING KUI LEE',
			dntg: 'MONKEY KING',
            birdingJoy:'BIRDING JOY',
            goldenCountry: 'GOLDEN COUNTRY'
        },
        qipaiKind: {
            zhajinhua3d: "3D GOLDEN FLOWER",
            bairen: 'Hundred people push the package',
            niniu: 'Tongbi cattle',
            tongbi: 'Tongbi pusher',
            paijiu: 'Grab the card',
            guandao: "Whipped egg",
            sangong: "THREE FACECARD",
            jialebipuke: "Caribbean Poker",
            ershiyidian: "BLACK JACK",
            paohuzi: "Running beard",
            shaibao: "Sic bo",
            bairenniuniu: "Multiplayer Niu-niu",
            sanzhangpuke: "Three poker",
            doudizhu1: "Landlords (rapid)",
            doudizhu2: "Landlords (no shuffle)",
            qiangzhuangtuitongzi: "Grab the pusher",
            shidianban: 'TEN POINT HALF',
            jokerNiuniu: "JOKER NIUNIU",
            developGame: "more games",
        },
        electronGame: {
            laohuji: "Slot machine",
            senlinwuhui: "Forest dance",
            taiqiudashi: "Billiard master",
            benchibaoma: "Mercedes-Benz BMW",
            shuiguopaidui: "Fruit party",
            feiqinzoushou: "Birds and beasts",
            wangzhezuqiu: "King football",
            hangjinlunpan: "Gold roulette",
            xingyunwu: "Lucky five",
            developGame: "More games"
        },
        MahjongKing: {
            guangdongmajiang: "Guangdong Mahjong",
            zhuajimajiang: "Catching chicken mahjong",
            dongbeimajiang: "Northeast Mahjong",
            errenmajiang: "Two mahjong",
            xueliumajiang: "Blood river mahjong",
            fanbeimajiang: "DOUBLE BLOOD",
            taimajiang: "Taiwan Mahjong",
            guojimajiang: "International mahjong",
            hangzhoumajiang: "Hangzhou Mahjong",
            kawufumajiang: "Card Wufu Mahjong",
            xuezhanmajiang: "Bleeding mahjong",
            fuzhoumajiang: "Fuzhou Mahjong",
            zhongyongmajiang: "Moderate mahjong"
        },
        hunterKing: {
            buniaolueshou: "Bird hunter",
            xingjidazhan: "Star Wars",
            xingyunbuyu: "Lucky fishing",
            developGame: "more games",
        }
    },
    linkUs: {
        title: 'Please leave your contact information',
        name: 'Name',
        mail: 'Mailbox',
        phone: 'Mobile phone',
        remark: 'Description',
        btnTxt: 'submit',
        captcha: 'Verification code',
        messages: {
            noName: 'Please provide a name, convenient customer service contact you!',
            noContact: 'Please provide a contact information, email or telephone number, please fill one!',
            noRemark: 'Please explain the situation you meet or want to know, at least 10 words above!',
            remarkLength: 'Insufficient length of message!',
            mailError: 'Email format error!',
            phoneError: 'Wrong format of phone number!'
        }
    }
}


// WEBPACK FOOTER //
// ./src/lang/en.js